import { BaseModel } from "./base.model";

export class MemberModel extends BaseModel{
    auto_id?:number;
    memberId: number;
    memberName: string | null;
    memberIC: string | null;
    memberOldIC: string | null;
    memberCitizenship: string | null;
    memberBirthYear: number | null;
    memberAddr1: string | null;
    memberAddr2: string | null;
    memberAddr3: string | null;
    memberZipCode: string | null;
    memberCity: string | null;
    memberAddrState: number | null;
    memberAddrDistrict: number | null;
    sex: string | null;
    raceCode: string | null;
    raceName: string | null;
    maritalStatusId: number | null;
    memberPhone: string | null;
    memberPhoneHome: string | null;
    memberEmail: string | null;
    incomeLevelId: number | null;
    educationLevelId: number | null;
    memberOtherActivities: string | null;
    memberOtherIncome: string | null;
    actFreqId: number | null;
    memberNotes1: string | null;
    memberNotes2: string | null;
    memberRegisterDate: string | null;
    memberImage: string | null;
    memberImageMD5: string | null;
    farmOwnerId: number | null;
    cardCollectBranch: number | null;
    //preRegId: number | null;
    bankId: number | null;
    lastUpdate: string | null;
    personUpdate: string | null;
    vendor_update: boolean | null;
    uip_elev: boolean | null;
    memberDUN: string | null;
    memberParlimen: string | null;
    memberDUNChecked: number;
    memberFarmDunUpdated: number;
    memberFormNo: string | null;
    memberFormReceiver: string | null;
    memberActive: number;
    memberStatus: number;
    memberParlimenId: number;
    memberDunId: number;
    member_created_at: string | null;
    member_created_by: number | null;
    accBankNo: string | null;
    stateName: string | null;
    districtName: string | null;
    parlimen: string | null;
    dun: string | null;
    maritalStatusName: string | null;
    incomeLevelName: string | null;
    bankName: string | null;
    educationLevelName: string | null;
    actFreqName: string | null;
    patgRegId: number | null;
    patgRegStatusId: number | null;
    
    // memberId:any;
    // memberName:any;
    // memberIC:any;
    // memberOldIC:any;
    // memberCitizenship:any;
    // memberBirthYear:any;
    // memberAddr1:any;
    // memberAddr2:any;
    // memberAddr3:any;
    // memberZipCode:any;
    // memberCity:any;
    // memberAddrState:any;
    // memberAddrDistrict:any;
    // sex:any;
    // raceCode:any;
    // maritalStatusId:any;
    // memberPhone:any;
    // memberPhoneHome:any;
    // memberEmail:any;
    // incomeLevelId:any;
    // educationLevelId:any;
    // memberOtherActivities:any;
    // memberOtherIncome:any;
    // actFreqId:any;
    // memberNotes1:any;
    // memberNotes2:any;
    // memberRegisterDate:any;
    // memberImage:any;
    // memberImageMD5:any;
    // farmOwnerId:any;
    // cardCollectBranch:any;
    // preRegId:any;
    // bankId:any;
    // lastUpdate:any;
    // personUpdate:any;
    // vendor_update:any;
    // uip_elev:any;
    // memberDUN:any;
    // memberParlimen:any;
    // memberDUNChecked:any;
    // memberFarmDunUpdated:any;
    // memberFormNo:any;
    // memberFormReceiver:any;
    // memberActive:any;
    // memberStatus:any;
    // memberParlimenId:any;
    // memberDunId:any;
    // member_created_at:any;
    // member_created_by:any;
    // accBankNo:any;
    // stateName:any;
    // districtName:any;
    // parlimen:any;
    // dun:any;
    // maritalStatusName:any;
    // raceName:any;
    // incomeLevelName:any;
    // bankName:any;
    // educationLevelName:any;
    // actFreqName:any;

    // constructor(original: Object) { 
    //   Object.assign(this, original);
    // }

    constructor(params: Partial<MemberModel> = {} as MemberModel) {
      super();
      Object.assign(this, params);
    }

    static createCopy(objectToCopy: MemberModel | null): MemberModel | null{
      if(objectToCopy === null) return null;
      return (JSON.parse(JSON.stringify(objectToCopy)));
    }

  }